import React from 'react';
import './Contact.css';
import HeaderComponent from '../../components/HeaderComponent';

const Contact: React.FC = () => {

  return (
    <div className="homepage">
      <HeaderComponent />
      <div className="content-home">
        <h3>Contact details:
        </h3>
        <p>Institute for Architecture of Application Systems <br /> Faculty 05: Computer science, electrical engineering and information technology
        <br /> Universität Stuttgart <br /> Pfaffenwaldring 47 <br />70569 Stuttgart</p>
        
      </div>
    </div>
  );
};

export default Contact;
